import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

var bnr1 = require('./../../images/background/bg-6.png');

class Testimonials2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            testimonials: [],
        };
    }
    sheetId = '1gPA0NAwMad3eDKRd7zsajwG7Z4Z7Vmfjjf0-XdzEYm0';
    componentDidMount(){
        function loadScript(src) {
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      this.fetchTestimonials();
    };

    fetchTestimonials = async () => {
        try {
            const response = await fetch(
                `https://docs.google.com/spreadsheets/d/${this.sheetId}/gviz/tq?tqx=out:json`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            const data = await response.text();
            const jsonData = JSON.parse(data.substr(47).slice(0, -2));
            console.log('Raw Data:', jsonData.table); // Log the raw data for debugging
            if(jsonData.table && jsonData.table.rows) {
            const formattedData = jsonData.table.rows.map((row) => {    
                const values = row.c;
                return {
                    timestamp: values[0] ? values[0].v : '',
                    reviewername: values[1] ? values[1].v : '',
                    email: values[2] ? values[2].v : '',
                    review: values[3] ? values[3].v : '',
                    rating: values[4] ? parseFloat(values[4].v) : 5, // Assuming the rating is in column 5
                }})

                console.log('Formatted Data:', formattedData);
            this.setState({ testimonials: formattedData });
            }
        } catch (error) {
            console.error('Error fetching data from Google Sheets:', error);
        }
    };

    renderStars = (rating) => {
        const fullStars = Math.floor(rating);
        const halfStar = rating % 1 !== 0;
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

        const starStyle = { color: "#FFD700", marginRight: "3px" }; // Add margin for spacing

        return (
            <>
                {[...Array(fullStars)].map((_, i) => (
                    <i key={`full-${i}`} className="fa fa-star" style={starStyle}></i>
                ))}
                {halfStar && <i className="fa fa-star-half-alt" style={starStyle}></i>}
                {[...Array(emptyStars)].map((_, i) => (
                    <i key={`empty-${i}`} className="fa fa-star-o" style={starStyle}></i>
                ))}
            </>
        );
    };

    render() {
        const { testimonials } = this.state;
        console.log(this.state.testimonials,'Testimonials:', testimonials); // Log the testimonials for debugging
        const options = {
            loop:true,
            autoplay:true,
            margin:30,
            nav:false,
            dots: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive:{
                0:{
                    items:1
                },
                991:{
                    items:1
                }
            }
        };

        return (
            <>
                <div className="section-full p-t80 bg-dark square_shape2  square_shape1 bg-moving mobile-page-padding" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                        <div className="section-content">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-white text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Client</span> Reviews</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            {/* TESTIMONIAL START */}
                            {testimonials.length > 0 ? (
                            <OwlCarousel
                                className="owl-carousel testimonial-home-2 p-b30"
                                {...options}
                                key={testimonials.length} 
                            >
                                {testimonials.map((item, index) => (
                                    <div className="item" key={index}>
                                        <div className="col-sm-12 col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8">
                                            <div className="testimonial-1 testimonial-bg m-a30 hover-animation-1 text-center text-white">
                                                <div className="testimonial-text">
                                                    <div className="review-stars">
                                                        {this.renderStars(item.rating)}
                                                    </div>
                                                    <p>{item.review}</p>
                                                </div>
                                                <div className="testimonial-detail clearfix">
                                                    <h4 className="testimonial-name m-b5">{item.reviewername}</h4>
                                                    {/* <span className="testimonial-position">{item.email}</span> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>
                        ) : (
                            <p className="text-white text-center">Loading Reviews...</p>
                        )}  
                            
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Testimonials2;